var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.targetSurveyType == 1)?_c('CityDataSummary'):(_vm.targetSurveyType == 2)?_c('FactFindingSummary'):(_vm.targetSurveyType == 3)?_c('ElectricitySummary'):(_vm.targetSurveyType == 4)?_c('RefrigerantSummary'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }